import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import { computed } from 'vue';
import stylesJS from '@/assets/styles.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'textItem',
  props: {
  id: {
    type: String,
    default: undefined
  },
  txt : {
    type: String,
    default: "",
  },
  styles : {
    type: String,
    default: "",
  },
  active : {
    type: Boolean,
    default: false,
  },
  ellipsis : {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props

const classList = computed(() => {
  // Import & defaults
  let importOBJ = stylesJS.get(props.styles)
  let iAlign = importOBJ.align || "l"
  iAlign = "align-" + iAlign
  let iMain = importOBJ.main || "h"
  iMain = "main-" + iMain
  let iBg = importOBJ.bg || "0"
  iBg = "bg-" + iBg
  let iFont = importOBJ.font || "m"
  iFont = "font-" + iFont

  return ['cursor-nosel', iMain, iAlign, iBg, iFont, props.ellipsis ? 'ellipsis' : '']
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(classList.value),
    id: __props.id
  }, _toDisplayString(__props.txt), 11, _hoisted_1))
}
}

})